(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3b99"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3b99"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $8EDuI = parcelRequire("8EDuI");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
function $a198c5b7f78064c1$var$App() {
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {});
}
var $a198c5b7f78064c1$export$2e2bcd8739ae039 = $a198c5b7f78064c1$var$App;



var $k8iTi = parcelRequire("k8iTi");
const $f25e85c08ff84b11$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8EDuI))).createRoot(document.getElementById("root"));
$f25e85c08ff84b11$var$root.render(/*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a198c5b7f78064c1$export$2e2bcd8739ae039), {})
}));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $k8iTi.default)();

})();
//# sourceMappingURL=index.29fffc3d.js.map
